import { ServiceDelivery } from "../domain/ServiceDelivery";
import { ServiceDeliveryRepository } from "../domain/ServiceDeliveryRepository";
import { CompanyRepository } from "../domain/CompanyRepository";
import MemoryItemsRepo, { getValue } from '@/modules/conector_ops/infra/MemoryRepositories';

export class MemoryServiceDeliveryRepo 
    implements ServiceDeliveryRepository {
    sds: ServiceDelivery[];
    company_repo: CompanyRepository;
    baseRepo: MemoryItemsRepo;

    constructor(sds: ServiceDelivery[], CompanyRepository: CompanyRepository) { 
        this.sds = [];
        this.company_repo = CompanyRepository
        sds?.forEach(item => {
            let sd = item;
            if(!(item instanceof ServiceDelivery)){
                sd = ServiceDelivery.fromPrimitive(item);
            }
            this.sds.push(sd.clone());
        });
        this.baseRepo = new MemoryItemsRepo(this.sds);
    }
    
    find_by_user_id(user_id: number) {
        return this.sds.filter(sd => sd.user_id === user_id).map(sd => sd.clone());
    }

    async find_by_id(sd_id: number): Promise<ServiceDelivery> {
        return this.sds.find(sd => sd.sd_id === sd_id)?.clone();
    }

    async save(sd_id: number, company_ids: number[]) {
        let sd = await this.find_by_id(sd_id)
        let companies = await this.company_repo.find_by_ids(company_ids)
        companies.forEach((company) => {
            if (!sd.companies.some((c) => c.id === company.id)) {
                sd.companies.push(company);
            }
        });
        sd.credits = sd.credits - sd.companies.length;

        const index = this.sds.findIndex(item => item.sd_id === sd_id);
        if (index !== -1) {
            this.sds[index] = sd.clone();
        } else {
            this.sds.push(sd.clone());
        }
    }

    async regenerate_invoice(charge_id: number) {
        let sd = this.sds.find(sd => sd.charge?.id === charge_id)
        console.log("Regenerating invoice for ", sd);
        if (sd) {
            sd.charge.invoice_pdf = "https://example.com/invoice.pdf";
        }
        return {job_id: 99999};
    }
    
    async find_by_criteria(
        crit: any[][],
        orderBy?: string,
        orderSort: 'asc' | 'desc' = 'asc',
        limit?: number
    ): Promise<any[]> {
        let results = await this.baseRepo.find_by_criteria(crit);
        if (orderBy) {
            results.sort((a, b) => {
                const valA = getValue(a, orderBy);
                const valB = getValue(b, orderBy);
                if (valA < valB) return orderSort === 'asc' ? -1 : 1;
                if (valA > valB) return orderSort === 'asc' ? 1 : -1;
                return 0;
            });
        }

        if (limit !== undefined) {
            results = results.slice(0, limit);
        }

        return results;
    }
}